import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { postNewExpressionParameter } from 'Services';
import { RQ_CREATE_EXPRESSION_PARAMETER, RQ_PARAMETERS } from 'Utils';

type Options = MutationOptions<AxiosResponse<CreateExpressionParameterRequest[]>, any, any, any>;

function useAddExpressionParameter(mutationOptions: Options) {
    const queryClient = useQueryClient();

    return useMutation([RQ_CREATE_EXPRESSION_PARAMETER], postNewExpressionParameter, {
        onSuccess: (data, variables, context) => {
            mutationOptions.onSuccess?.(data, variables, context);
            queryClient.invalidateQueries([RQ_PARAMETERS]);
        },
        onError: mutationOptions.onError
    });
}

export default useAddExpressionParameter;
